import { Analytics } from './analytics';
import { ItemAction } from '../../../item/actions/item_action';

export class ZoomImageAnalytics extends Analytics {
  constructor() {
    super();
    ItemAction.ZOOM_IMAGE_EVENT.on((data) => {
      this.run(() => {
        const item = data.analyticsData.item;
        const productName = item.getProductName();
        const medicalMaterialType = item.getMedicalMaterialType();
        const linkAnalyticsData = {
          server: 'club/pc',
          fName: '商品詳細画像_クリック',
          events: ['event156'],
          items: [this.items(productName, medicalMaterialType, item._events)],
          sku: productName,
          displayItemImage: this.displayItemPicture(data.analyticsData.index, data.analyticsData.length, productName),
          club: {
            server: 'club/pc',
            events: ['event156'],
            products: [this.products(item._catalogItemCode, medicalMaterialType, item._events)],
            prop5: '商品詳細画像_クリック',
            prop25: item._catalogItemCode,
            prop65: this.displayItemPicture(data.analyticsData.index, data.analyticsData.length, item._catalogItemCode)
          }
        };
        window.sc_trackLinkAll(linkAnalyticsData, data.target, 'o', data.linkName);
      });
    });
  }
  private displayItemPicture(id, length, catalogItemCode): string {
    return `${catalogItemCode}_${id}/${length}`;
  }

  private items(productName: string, evars: string, events: string[]) {
    return {
      category: '',
      productName: productName,
      quantity: '',
      price: '',
      events: [events],
      evars: this.medicalMaterialType(evars)
    };
  }

  private products(productName: string, evars: string, events: string[]) {
    return {
      category: '',
      productName: productName,
      quantity: '',
      price: '',
      events: [events],
      evars: this.eVar79(evars)
    };
  }

  private medicalMaterialType(evars: string) {
    return { medicalMaterialType: evars };
  }

  private eVar79(evars: string) {
    return { eVar79: evars };
  }
}
